// Mock data for Shape & Shine by Sandra Silva

export const brandInfo = {
  name: "Shape & Shine",
  tagline: "by Sandra Silva",
  description: "Beleza e tratamento corporal de excelência",
  logo: "https://customer-assets.emergentagent.com/job_b72b398f-341e-497f-a4a4-90e57f148212/artifacts/7jm7gror_logo-ss.png"
};

export const contactInfo = {
  address: "Rua Tomé Barros Queirós n°34",
  postalCode: "3810-833 Oliveirinha",
  email: "geral@shapeandshine.pt",
  phone: "+351936694088",
  whatsapp: "351936694088",
  instagram: "https://instagram.com/shapeandshine.pt",
  facebook: "https://facebook.com/shapeandshine.pt"
};

export const services = [
  {
    id: 1,
    category: "Depilação",
    icon: "Sparkles",
    items: [
      { name: "Depilação a Laser - Axilas", price: "A definir", duration: "30 min" },
      { name: "Depilação a Laser - Virilhas", price: "A definir", duration: "30 min" },
      { name: "Depilação a Laser - Pernas Completas", price: "A definir", duration: "60 min" },
      { name: "Depilação a Laser - Buço", price: "A definir", duration: "15 min" },
      { name: "Depilação a Laser - Corpo Inteiro", price: "A definir", duration: "120 min" }
    ]
  },
  {
    id: 2,
    category: "Lipozero",
    icon: "Zap",
    description: "Tratamento completo com Laser Frio, Radiofrequência, Cavitação, Vácuo e LED",
    items: [
      { name: "Lipozero - Sessão Individual", price: "A definir", duration: "60 min" },
      { name: "Lipozero - Pack 5 Sessões", price: "A definir", duration: "60 min/sessão" },
      { name: "Lipozero - Pack 10 Sessões", price: "A definir", duration: "60 min/sessão" }
    ]
  },
  {
    id: 3,
    category: "Pressoterapia",
    icon: "Heart",
    items: [
      { name: "Pressoterapia - Sessão Individual", price: "A definir", duration: "45 min" },
      { name: "Pressoterapia - Pack 5 Sessões", price: "A definir", duration: "45 min/sessão" },
      { name: "Pressoterapia - Pack 10 Sessões", price: "A definir", duration: "45 min/sessão" }
    ]
  },
  {
    id: 4,
    category: "Sessões de Beleza",
    icon: "Gem",
    items: [
      { name: "Maquilhagem Social", price: "A definir", duration: "45 min" },
      { name: "Maquilhagem Noiva", price: "A definir", duration: "90 min" },
      { name: "Consultoria de Imagem", price: "A definir", duration: "60 min" },
      { name: "Tratamento Facial Completo", price: "A definir", duration: "60 min" }
    ]
  }
];

export const maryKayProducts = [
  {
    id: 1,
    category: "Cuidados de Pele",
    products: [
      { name: "TimeWise® Conjunto Milagroso", price: "A definir", description: "Sistema anti-idade completo", image: "https://images.unsplash.com/photo-1621770522934-bfcc3b284df7?w=400&h=400&fit=crop" },
      { name: "Botanical Effects®", price: "A definir", description: "Cuidado natural da pele", image: "https://images.unsplash.com/photo-1583334516865-e4240dc3fc79?w=400&h=400&fit=crop" },
      { name: "Clear Proof®", price: "A definir", description: "Tratamento para pele com acne", image: "https://images.unsplash.com/photo-1621770522850-b226f8e00158?w=400&h=400&fit=crop" }
    ]
  },
  {
    id: 2,
    category: "Maquilhagem",
    products: [
      { name: "Base Líquida TimeWise®", price: "A definir", description: "Cobertura média a completa", image: "https://images.unsplash.com/photo-1590156576841-033939aa8c43?w=400&h=400&fit=crop" },
      { name: "Paleta de Sombras", price: "A definir", description: "Cores versáteis", image: "https://images.unsplash.com/photo-1523634118614-82b2685ee3df?w=400&h=400&fit=crop" },
      { name: "Batom Gel Semi-Brilhante", price: "A definir", description: "Hidratação duradoura", image: "https://images.pexels.com/photos/4889718/pexels-photo-4889718.jpeg?w=400&h=400&fit=crop" }
    ]
  },
  {
    id: 3,
    category: "Fragrâncias",
    products: [
      { name: "Thinking of You®", price: "A definir", description: "Fragrância floral", image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400&h=400&fit=crop" },
      { name: "Journey®", price: "A definir", description: "Fragrância sofisticada", image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?w=400&h=400&fit=crop" }
    ]
  },
  {
    id: 4,
    category: "Corpo & Sol",
    products: [
      { name: "Satin Hands®", price: "A definir", description: "Conjunto para mãos sedosas", image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=400&fit=crop" },
      { name: "Satin Lips®", price: "A definir", description: "Conjunto para lábios macios", image: "https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=400&h=400&fit=crop" },
      { name: "Sun Care", price: "A definir", description: "Proteção solar", image: "https://images.unsplash.com/photo-1556229010-aa3f7ff66b24?w=400&h=400&fit=crop" }
    ]
  }
];

export const aboutContent = {
  title: "Sobre Nós",
  subtitle: "Conheça a Sandra Silva",
  description: `A Shape & Shine nasceu da paixão pela beleza e pelo bem-estar. Com anos de experiência na área da estética e como consultora Mary Kay, a Sandra Silva decidiu criar um espaço onde cada cliente se sente especial e único.

O nosso compromisso é oferecer tratamentos de excelência, utilizando as mais avançadas tecnologias em depilação a laser, tratamentos corporais e produtos de beleza de alta qualidade.

Na Shape & Shine, acreditamos que cada pessoa merece sentir-se confiante e radiante. É por isso que personalizamos cada tratamento às necessidades individuais de cada cliente.`,
  values: [
    { title: "Excelência", description: "Comprometimento com os melhores resultados" },
    { title: "Confiança", description: "Relações duradouras com os nossos clientes" },
    { title: "Inovação", description: "Tecnologias de ponta em todos os tratamentos" },
    { title: "Personalização", description: "Cada cliente é único e especial" }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Maria Santos",
    text: "Adorei os resultados da depilação a laser! A Sandra é super profissional e atenciosa.",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Ferreira",
    text: "Os tratamentos de Lipozero são incríveis. Já notei diferença após as primeiras sessões!",
    rating: 5
  },
  {
    id: 3,
    name: "Carla Oliveira",
    text: "Finalmente encontrei produtos Mary Kay de qualidade. Recomendo a todos!",
    rating: 5
  }
];

export const workingHours = [
  { day: "Segunda-feira", hours: "09:00 - 19:00" },
  { day: "Terça-feira", hours: "09:00 - 19:00" },
  { day: "Quarta-feira", hours: "09:00 - 19:00" },
  { day: "Quinta-feira", hours: "09:00 - 19:00" },
  { day: "Sexta-feira", hours: "09:00 - 19:00" },
  { day: "Sábado", hours: "09:00 - 13:00" },
  { day: "Domingo", hours: "Encerrado" }
];
